module.exports = __webpack_public_path__ + "img/1-06.8c7574aa.jpg";